export default __webpack_public_path__ + "static/media/return.a9db5732.svg";